import React from 'react';
import { useTranslation } from 'react-i18next';

const Cv = () => {
  const [t] = useTranslation('global');
  return (
    <section className="cv" id="cv">
      <div className="text-center">
        <h1 className="title-cv">{t('cv.title')}</h1>
        <div className="cvdesc">
          <p>{t('cv.description')}</p>
        </div>

        <p className="text-white">
          ⬇
          {t('cv.download1')}
          {' '}
          ⬇
        </p>
        <a href="https://1drv.ms/w/s!AjZA4iH01A5qgYwLNMYTtA4VfT2_QA?e=stUeI2" target="_blank" rel="noreferrer">
          <button className="btn-cv">{t('cv.download2')}</button>
        </a>
      </div>
    </section>
  );
};

export default Cv;
